import { useState } from "react";
import { faqs } from "@/mocks/chigua";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-background-100 py-12 md:py-16">
      <div className="mx-auto w-full max-w-4xl px-4 md:px-6">
        <div className="text-center">
          <p className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold tracking-wide text-accent-900">
            <i className="ri-question-line" aria-hidden="true"></i>
            常见问题
          </p>
          <h2 className="font-heading mt-3 text-2xl font-bold text-foreground-950 md:text-3xl">
            你可能想问的都在这里
          </h2>
        </div>

        <div className="mt-8 space-y-3">
          {faqs.map((f, i) => {
            const isOpen = openIdx === i;
            return (
              <div
                key={f.q}
                className="overflow-hidden rounded-2xl border border-background-200/80 bg-background-50"
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(isOpen ? -1 : i)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                >
                  <span className="flex items-start gap-3">
                    <i
                      className={`${isOpen ? "ri-question-fill text-primary-600" : "ri-question-line text-primary-500"} mt-0.5 text-lg`}
                      aria-hidden="true"
                    ></i>
                    <span className="text-[15px] font-semibold text-foreground-950">{f.q}</span>
                  </span>
                  <i
                    className={`${isOpen ? "ri-subtract-line" : "ri-add-line"} text-xl text-foreground-500`}
                    aria-hidden="true"
                  ></i>
                </button>
                {isOpen && (
                  <div className="px-5 pb-5 pl-14">
                    <p className="text-sm leading-relaxed text-foreground-700">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}